import { useApi } from "../useApi";

export const useGithubLogin = () => {
  const loading = useState<boolean>("githubLogin:loading", () => false);
  const error = useState<string | null>("githubLogin:error", () => null);
  const api = useApi();

  const githubLogin = async () => {
    try {
      error.value = null;
      loading.value = true;

      const base = api.request.config.BASE;
      const { url } = (await (await fetch(`${base}/v1/auth/github/login`)).json()) as { url: string };
      window.location.href = url;
    } catch (err) {
      error.value = "Failed to initialize GitHub login";
      console.error("Login error:", err);
    } finally {
      loading.value = false;
    }
  };

  return {
    githubLogin,
    loading,
    error,
  };
};
